export enum CHAMPIONSHIPS {
  SERIE_A = "serie_a",
  PREMIER_LEAGUE = "premier_league",
  SERIE_B = "serie_b",
  LIGA_MX = "ligamax",
  BUNDESLIGA = "bundesliga",
  LA_LIGA = "la_liga",
  PRIMEIRA_LIGA = "primeira_liga",
  CHAMPIONS_LEAGUE = "champions_league",
  EUROPA_LEAGUE = "europa_league",
}

export enum MARKETS {
  H2H = "h2h",
  TOTALS = "totals",
}
